import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { reduxForm, Field } from 'redux-form'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Button, Confirm } from 'semantic-ui-react'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { Grid, Label, TextArea, Radio } from 'semantic-ui-react'
import { VendorInformationContainer, ContactContainer, ExperienceContainer } from './styled'
import VendorSelectModal from './VendorSelectModal'
import ContactModal from './ContactModal'
import ExperienceModal from './ExperienceModal'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getBusinessPartners } from 'ducks/options'
import { getVendorDetail } from 'ducks/shortList'
import { Table, TableBody, TableRow, TableHead, TableCell, TableContainer, Paper } from '@material-ui/core'
import r from 'reactotron-react-js'

const VendorInformation = (props) => {
  const { valueForm, change, isDisplay = false, members, businessPartners, showCollapse = true } = props
  const [showVendorInfo, setShowVendorInfo] = useState(true)
  const [showVendorModal, setShowVendorModal] = useState(false)
  const [showContactModal, setShowContactModal] = useState(false)
  const [showExperienceModal, setShowExperienceModal] = useState(false)
  const [vendorIndex, setVendorIndex] = useState(null)
  const [showConfirmDeleteVendor, setShowConfirmDeleteVendor] = useState(false)

  useEffect(() => {
    if (!members.data.length && !members.loading) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }

    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  const vendorDataEditable = (index) => {
    return editableForm() && valueForm.vendors && valueForm.vendors[index] ? true : false
  }

  const memberOptions = members.data.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))
  var docYear = (valueForm.documentDate || new Date()).getFullYear()
  docYear = docYear < 2500 ? docYear + 543 : docYear
  const docYears = [docYear - 1, docYear - 2, docYear - 3, docYear - 4, docYear - 5]

  const vendorLength = () => {
    var vl = valueForm && valueForm.vendors ? (valueForm.vendors || []).length : 0

    return vl > 3 ? vl : 3
  }

  const renderVendorName = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}></TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const vendorCode = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].vendorCode || '' : ''
          const vendor = businessPartners.data.find(v => v.value === vendorCode)
          const vendorName = (vendor ? vendor.text : '').replace(`${vendorCode} : `, '')

          return (
            <TableCell style={{ fontWeight: 'bold', verticalAlign: 'top' }}>
              <Grid columns='equal' style={{ marginBottom: 'unset' }}>
                <Grid.Row style={{ paddingBottom: vendorName ? '5px' : '' }}>
                  <Grid.Column floated='left'>{`Vendor ${i + 1} ${vendorCode ? `(${vendorCode})` : ''}`}</Grid.Column>
                  <Grid.Column floated='right' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    { 
                      vendorDataEditable(i) ? 
                        <Button 
                          size='mini' 
                          compact 
                          icon='trash'
                          color='red'
                          type='button'
                          onClick={() => { 
                            setVendorIndex(i)
                            setShowConfirmDeleteVendor(true)
                          }}
                        /> : null
                    }
                  </Grid.Column>
                </Grid.Row>
                {vendorName ? <Grid.Row style={{ paddingTop: '0px' }}><Grid.Column>{vendorName}</Grid.Column></Grid.Row> : null}
              </Grid>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderContact = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold', verticalAlign: 'top' }}>Contact Name</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const value = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].contacts || [] : []
          const editable = editableForm() && valueForm.vendors && valueForm.vendors[i] ? true : false

          return (
            <TableCell style={{ verticalAlign: 'top' }}>
              <ContactContainer>
                {
                  editable ?
                    <Button
                      compact
                      content='Edit Contact'
                      icon='pencil'
                      labelPosition='right'
                      color='blue'
                      style={{ marginBottom: '10px', fontSize: '12px' }}
                      type='button'
                      onClick={() => {
                        setVendorIndex(i)
                        setShowContactModal(true)
                      }}
                    /> : null
                }
                {
                  value.map(u => {
                    return (
                      <div className='contactRow'>
                        <div>{u.name}</div>
                        <div>{u.tel}</div>
                        <div>{u.email}</div>
                      </div>
                    )
                  })
                }
                <Field 
                  name={`vendors[${i}].contacts`}
                  type={type.labelOnly}
                  component={FieldInput}
                />
              </ContactContainer>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderAddress = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}>Address</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => 
          <TableCell>
            <Field
              name={`vendors[${i}].address`}
              editable={vendorDataEditable(i)}
              containerStyle={{ margin: '0px' }}
              style={{ margin: '0px' }}
              type={type.textArea}
              component={FieldInput}
            />
          </TableCell>
        )
      }
    </TableRow>
  )

  const renderProposeBy = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}>Propose by</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const editable = editableForm() && valueForm.vendors && valueForm.vendors[i] ? true : false
          return (
            <TableCell>
              <Field
                name={`vendors[${i}].proposeBy`}
                editable={editable}
                loading={members.loading}
                containerStyle={{ margin: '0px' }}
                style={{ margin: '0px' }}
                options={memberOptions}
                type={type.select}
                component={FieldInput} />
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderYearEstablished = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}>ปีที่ก่อตั้ง</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => 
          <TableCell>
            <Field
              name={`vendors[${i}].yearEstablished`}
              editable={vendorDataEditable(i)}
              containerStyle={{ margin: '0px' }}
              style={{ margin: '0px' }}
              type={type.text}
              component={FieldInput}
            />
          </TableCell>
        )
      }
    </TableRow>
  )

  const renderRegisteredCapital = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold' }}>ทุนจดทะเบียน</TableCell>
      {[...Array(vendorLength())].map((e, i) => renderNumberField(`vendors[${i}].registeredCapital`, i))}
    </TableRow>
  )

  const renderIncome = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>รายรับ (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].incomes[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderProfit = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>กำไร/ขาดทุน (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].profits[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderShareholder = () => {
    var result = [<TableRow><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>ส่วนของผู้ถือหุ้น (ย้อนหลัง 3-5 ปี)</TableCell></TableRow>]

    docYears.forEach((year, yearIndex) => {
      var elements = []
      for (let index = 0; index < vendorLength(); index++) {
        if (index === 0) {
          elements = [<TableCell variant='head' style={{ fontWeight: 'bold' }}>{year}</TableCell>]
        }
        elements.push(renderNumberField(`vendors[${index}].shareholders[${yearIndex}].value`, index))
      }

      result.push(<TableRow>{elements}</TableRow>)
    })

    return result
  }

  const renderNumberField = (name, index) => (
    <TableCell>
      <Field
        name={name}
        editable={vendorDataEditable(index)}
        containerStyle={{ margin: '0px' }}
        style={{ margin: '0px' }}
        type={type.number}
        component={FieldInput}
      />
    </TableCell>
  )

  const renderExperience = () => (
    <TableRow>
      <TableCell variant='head' style={{ fontWeight: 'bold', verticalAlign: 'top' }}>ประสบการณ์</TableCell>
      {
        [...Array(vendorLength())].map((e, i) => {
          const value = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i].experience || [] : []
          const editable = editableForm() && valueForm.vendors && valueForm.vendors[i] ? true : false

          return (
            <TableCell style={{ verticalAlign: 'top' }}>
              <ExperienceContainer>
                {
                  !editable ? null :
                    <Button
                      compact
                      content='Edit Experience'
                      icon='pencil'
                      labelPosition='right'
                      color='blue'
                      type='button'
                      style={{ marginBottom: '10px', fontSize: '12px' }}
                      onClick={() => {
                        setVendorIndex(i)
                        setShowExperienceModal(true)
                      }}
                    />
                }
                {value.map((ex, i) => <div>{`${i + 1}. ${ex}`}</div>)}
              </ExperienceContainer>
            </TableCell>
          )
        })
      }
    </TableRow>
  )

  const renderPqPart = () => {
    var { pqs, status } = valueForm

    if ((pqs || []).length > 0 && status === 4) {
      return (
        <React.Fragment>
          <TableRow style={{ background: '#F5F5F5' }}><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>Pre-Q Part A</TableCell></TableRow>
          <TableRow>
            <TableCell variant='head' style={{ fontWeight: 'bold' }}>Score</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>{pq.score}</TableCell>
                )
              })
            }
          </TableRow>
          <TableRow>
            <TableCell variant='head' style={{ fontWeight: 'bold' }}>Percentage</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>{Number(pq.percentage).toFixed(2)} %</TableCell>
                )
              })
            }
          </TableRow>
          <TableRow>
            <TableCell variant='head' style={{ fontWeight: 'bold' }}>Result</TableCell>
            {
              [...Array(vendorLength())].map((e, i) => {
                const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                const pq = pqs.find(x => x.shortListVendorId === vendor.id )

                return (
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>
                    <Label color={Number(pq.percentage) >= 70 ? 'green' : 'gray'}>ผ่าน</Label>
                    <Label color={Number(pq.percentage) >= 70 ? 'gray' : 'red'}>ไม่ผ่าน</Label>
                  </TableCell>
                )
              })
            }
          </TableRow>
        </React.Fragment>
        
      )
    } else {
      return null
    }
  }

  const renderEvaluationResult = () => {
    const { status, evaluations, committees } = valueForm

    if (status === 4) {
      return (
        <React.Fragment>
          <TableRow style={{ background: '#F5F5F5' }}><TableCell variant='head' colSpan={`${vendorLength() + 1}`} style={{ fontWeight: 'bold' }}>Evaluation</TableCell></TableRow>
          {
            committees.map((c) => {
              return (
                <TableRow>
                  <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>{c.fullname || c.username}</TableCell>
                  {
                    [...Array(vendorLength())].map((e, i) => {
                      const vendor = valueForm.vendors && valueForm.vendors[i] ? valueForm.vendors[i] : {}
                      const ev = evaluations.find(x => x.committeeUser === c.username )
                      const evResult = ev.evaluations.find(x => x.shortListVendorId === vendor.id) || {}

                      return (
                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right' }}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                              <Radio label='ผ่าน' checked={evResult.evaluation} />
                              <Radio style={{ marginLeft: '5px' }} label='ไม่ผ่าน' checked={evResult.evaluation === false} />
                            </div>
                            <div style={{ marginTop: '5px' }} >
                              <TextArea 
                                style={{ 
                                  fontFamily: 'IBM Plex Sans Thai',
                                  borderRadius: '4px', 
                                  border: '1px solid rgba(34,36,38,.15)', 
                                  padding: '6px 10px',
                                  width: '100%' 
                                }} 
                                disabled 
                                value={evResult.comment} />
                            </div>
                          </div>
                        </TableCell>
                      )
                    })
                  }
                </TableRow>
              )
            })
          }
          
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  return (
    <React.Fragment>
      <Card style={{ marginTop: '10px' }}>
        <CardHeader
          title='Vendor Information'
          action={
            showCollapse ? 
            <IconButton aria-label='Expand' onClick={() => setShowVendorInfo(!showVendorInfo)}>
              {showVendorInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton> : null
          }
        />
        <Collapse in={showVendorInfo}>
          <CardContent>
            <VendorInformationContainer>
              {
                editableForm() ?
                  <React.Fragment>
                    <Field name='vendorErrorMessage' type={type.labelOnly} component={FieldInput} /> 
                    <Button 
                      type='button' 
                      content='Add Vendor' 
                      color='primary' 
                      disabled={(valueForm.vendors || []).length > 9} 
                      onClick={() => setShowVendorModal(true)} 
                    />
                  </React.Fragment> : null
              }
              <TableContainer style={{ marginTop: (editableForm() ? '10px' : '0px'), border: 'solid 1px #C5C5C5', borderRadius: '5px' }} component={Paper}>
                <Table>
                  <TableHead>
                    {renderVendorName()}
                  </TableHead>
                  <TableBody>
                    {renderContact()}
                    {renderAddress()}
                    {renderProposeBy()}
                    {renderYearEstablished()}
                    {renderRegisteredCapital()}
                    {renderIncome()}
                    {renderProfit()}
                    {renderShareholder()}
                    {renderExperience()}
                    {renderPqPart()}
                    {renderEvaluationResult()}
                  </TableBody>
                </Table>
              </TableContainer>
            </VendorInformationContainer>
          </CardContent>
        </Collapse>
      </Card>
      {
        showVendorModal ?
          <VendorSelectModal
            onClose={() => setShowVendorModal(false)}
            onSelect={(value) => {
              props.getVendorDetail(value, (data) => {
                const findData = (key, year) => {
                  var result = (data[key] || []).find(x => x.year === year)
                  return result ? result.value : 0
                }

                var index = (valueForm.vendors || []).length
                change(`vendors[${index}].vendorCode`, value)
                change(`vendors[${index}].address`, data.address)
                change(`vendors[${index}].contacts`, data.contacts)
                change(`vendors[${index}].proposeBy`, props.username)
                change(`vendors[${index}].yearEstablished`, data.yearEstablished)
                change(`vendors[${index}].registeredCapital`, data.registeredCapital)
                change(`vendors[${index}].incomes`, docYears.map((y) => ({ year: y, value: findData('incomes', y) })))
                change(`vendors[${index}].profits`, docYears.map((y) => ({ year: y, value: findData('profits', y) })))
                change(`vendors[${index}].shareholders`, docYears.map((y) => ({ year: y, value: findData('shareholders', y) })))
                change(`vendors[${index}].experience`, data.experience)
                setShowVendorModal(false)
              })
            }}
            selectedVendor={(valueForm.vendors || []).map(v => v.vendorCode)}
          /> : null
      }
      {
        showContactModal ?
          <ContactModal
            onClose={() => setShowContactModal(false)}
            vendorData={valueForm.vendors[vendorIndex]}
            vendorIndex={vendorIndex}
            onSave={(value, index) => {
              change(`vendors[${index}].contacts`, value)
              setVendorIndex(null)
              setShowContactModal(false)
            }}
          /> : null
      }
      {
        showExperienceModal ?
          <ExperienceModal
            onClose={() => setShowExperienceModal(false)}
            vendorData={valueForm.vendors[vendorIndex] || { experience: [''] }}
            vendorIndex={vendorIndex}
            onSave={(value, index) => {
              change(`vendors[${index}].experience`, value)
              setVendorIndex(null)
              setShowExperienceModal(false)
            }}
          /> : null
      }
      <Confirm
        open={showConfirmDeleteVendor}
        content='Are you sure to delete this vendor?'
        onCancel={() => {
          setShowConfirmDeleteVendor(false)
          setVendorIndex(null)
        }}
        onConfirm={() => {
          const vendors = valueForm.vendors || []
          vendors.splice(vendorIndex, 1)
          change('vendors', vendors)
          setShowConfirmDeleteVendor(false)
          setVendorIndex(null)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  return ({
    members: {
      data: state.member.members,
      loading: state.member.memberLoading
    },
    username: username,
    businessPartners: state.options.businessPartners,
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  getBusinessPartners,
  getVendorDetail,
  getAllMembers
}

// const FormVendorInformation = reduxForm({
//   form: 'formShortList',
//   //enableReinitialize: true,
// })(VendorInformation)

// export const VendorInformationForm = connect(mapStateToProps, mapDispatchToProps)(FormVendorInformation)
export default connect(mapStateToProps, mapDispatchToProps)(VendorInformation)